import React, { useState, useEffect } from "react";
import {
  ref,
  onValue,
  push,
  set,
  update,
  serverTimestamp,
  get,
} from "firebase/database";
import { realTimeDB } from "../../firebase.config";
import axios from "axios";

const AdminChat = () => {
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [psychologists, setPsychologists] = useState([]);
  const [messages, setMessages] = useState([]);
  const [messageText, setMessageText] = useState("");
  const [unreadChats, setUnreadChats] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Detect mobile
  const [user, setUser] = useState(null);
  const adminEmail = "psycureadmin@gmail.com";

  // Fetch chats and psychologists
  useEffect(() => {
    const chatsRef = ref(realTimeDB, "/chats");
    onValue(chatsRef, (snapshot) => {
      const data = snapshot.val();
      const parsedChats = data
        ? Object.entries(data).map(([id, chat]) => ({ id, ...chat }))
        : [];
      setChats(parsedChats);
      const unread = parsedChats.filter((chat) => chat.newMessage);
      setUnreadChats(unread.map((chat) => chat.id));
    });

    axios
      .get(`https://api.thepsycure.com/psychologists/`)
      .then((data) => setPsychologists(data.data))
      .catch((err) => console.log(err));
  }, []);

  // Fetch messages for selected chat
  useEffect(() => {
    if (!selectedChat) return;
    const messagesRef = ref(realTimeDB, `/chats/${selectedChat.id}/messages`);
    const chatRef = ref(realTimeDB, `/chats/${selectedChat.id}`);
    const unsubscribe = onValue(messagesRef, (snapshot) => {
      const data = snapshot.val();
      const parsedMessages = data ? Object.values(data) : [];
      setMessages((prevMessages) => {
        if (JSON.stringify(prevMessages) !== JSON.stringify(parsedMessages)) {
          return parsedMessages;
        }
        return prevMessages;
      });
      get(chatRef).then((snap) => {
        if (snap.exists() && snap.val().newMessage) {
          update(chatRef, { newMessage: false });
        }
      });
      setUnreadChats((prev) => prev.filter((chatId) => chatId !== selectedChat.id));
    });
    return () => unsubscribe();
  }, [selectedChat]);

  // Detect screen size changes
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch users
  useEffect(() => {
    const fetchUser = async () => {
      await axios
        .get(`https://api.thepsycure.com/users/`)
        .then((data) => setUser(data.data))
        .catch((err) => console.log(err));
    };
    fetchUser();
  }, []);

  const sendMessage = async () => {
    if (messageText.trim() && selectedChat) {
      const newMessageRef = push(ref(realTimeDB, `/chats/${selectedChat.id}/messages`));
      set(newMessageRef, {
        text: messageText,
        timestamp: serverTimestamp(),
        sender: adminEmail,
        receiver: selectedChat.id.split("_")[0],
        userEmail: adminEmail,
      });
      const chatRef = ref(realTimeDB, `/chats/${selectedChat.id}`);
      update(chatRef, { newAdminMessage: true });
      const tokenRef = ref(realTimeDB, `/chats/${selectedChat.id}`);
      const tokenSnapshot = await get(tokenRef);
      const fcmToken = tokenSnapshot.val();
      await axios
        .post("https://api.thepsycure.com/sendNotification", {
          token: fcmToken?.token,
          title: "e-Bondhu",
          body: `${messageText}`,
        })
        .then((data) => {
          // console.log(data)
        })
        .catch((err) => console.log(err));
      setMessageText("");
    }
  };

  const assignPsychologist = (psychologistId) => {
    if (selectedChat) {
      const chatRef = ref(realTimeDB, `/chats/${selectedChat.id}`);
      update(chatRef, { psychologistId });
      alert("Psychologist assigned successfully.");
    }
  };

  return (
    <div>
      <h2>Admin Dashboard</h2>
      {isMobile ? (
        selectedChat ? (
          // Mobile: Chat View
          <div style={{ display: "flex", flexDirection: "column", height: "80vh" }}>
            <button
              onClick={() => setSelectedChat(null)}
              style={{ padding: "10px", marginBottom: "10px" }}
            >
              Back to Chats
            </button>
            <div style={{ flex: 1, overflowY: "auto", padding: "10px" }}>
              {messages.map((msg, index) => (
                <div key={index} style={{ marginBottom: "10px" }}>
                  <p>
                    <strong>{msg.sender === adminEmail ? "You" : "User"}:</strong> {msg.text}
                  </p>
                  <small>{new Date(msg.timestamp).toLocaleString()}</small>
                </div>
              ))}
            </div>
            <div style={{ padding: "10px" }}>
              <textarea
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                placeholder="Type a message..."
                style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
              />
              <button onClick={sendMessage}>Send</button>
            </div>
            <div style={{ padding: "10px" }}>
              <h3>Assign Psychologist</h3>
              <select
                onChange={(e) => assignPsychologist(e.target.value)}
                defaultValue=""
                style={{ width: "100%", padding: "5px" }}
              >
                <option value="" disabled>
                  Select Psychologist
                </option>
                {psychologists.map((psych) => (
                  <option key={psych?._id} value={psych?._id}>
                    {psych.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ) : (
          // Mobile: Chat List
          <div>
            <h3>User Chats</h3>
            <ul style={{ padding: 0, listStyle: "none" }}>
              {chats.map((chat) => (
                <li
                  key={chat.id}
                  onClick={() => setSelectedChat(chat)}
                  style={{
                    cursor: "pointer",
                    padding: "15px",
                    borderBottom: "1px solid #ccc",
                  }}
                >
                  {user?.find((user) => user?._id === chat.id.split("_")[0])?.name} (Assigned:{" "}
                  {psychologists?.find((psychologist) => psychologist?._id === chat.psychologistId)
                    ?.name || "Admin"}
                  )
                  {unreadChats.includes(chat.id) && (
                    <span
                      style={{
                        display: "inline-block",
                        marginLeft: "10px",
                        width: "10px",
                        height: "10px",
                        backgroundColor: "red",
                        borderRadius: "50%",
                      }}
                    ></span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )
      ) : (
        // Desktop Layout
        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ flex: "0 0 200px" }}>
            <h3>User Chats</h3>
            <ul style={{ padding: 0, listStyle: "none" }}>
              {chats.map((chat) => (
                <li
                  key={chat.id}
                  onClick={() => setSelectedChat(chat)}
                  style={{
                    cursor: "pointer",
                    fontWeight: selectedChat?.id === chat.id ? "bold" : "normal",
                    padding: "10px",
                  }}
                >
                  {user?.find((user) => user?._id === chat.id.split("_")[0])?.name} (Assigned:{" "}
                  {psychologists?.find((psychologist) => psychologist?._id === chat.psychologistId)
                    ?.name || "Admin"}
                  )
                  {unreadChats.includes(chat.id) && (
                    <span
                      style={{
                        display: "inline-block",
                        marginLeft: "10px",
                        width: "10px",
                        height: "10px",
                        backgroundColor: "red",
                        borderRadius: "50%",
                      }}
                    ></span>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div style={{ flex: 1 }}>
            {selectedChat ? (
              <div>
                <h3>
                  Chat with{" "}
                  {user?.find((user) => user?._id === selectedChat.id.split("_")[0])?.name}
                </h3>
                <div
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    height: "300px",
                    overflowY: "scroll",
                    marginBottom: "10px",
                  }}
                >
                  {messages.map((msg, index) => (
                    <div key={index} style={{ marginBottom: "10px" }}>
                      <p>
                        <strong>{msg.sender === adminEmail ? "You" : "User"}:</strong> {msg.text}
                      </p>
                      <small>{new Date(msg.timestamp).toLocaleString()}</small>
                    </div>
                  ))}
                </div>
                <textarea
                  value={messageText}
                  onChange={(e) => setMessageText(e.target.value)}
                  placeholder="Type a message..."
                  style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
                />
                <button onClick={sendMessage}>Send</button>
              </div>
            ) : (
              <p>Select a chat to view messages</p>
            )}
          </div>
          {selectedChat && (
            <div style={{ flex: "0 0 200px" }}>
              <h3>Assign Psychologist</h3>
              <select
                onChange={(e) => assignPsychologist(e.target.value)}
                defaultValue=""
                style={{ width: "100%", padding: "5px" }}
              >
                <option value="" disabled>
                  Select Psychologist
                </option>
                {psychologists.map((psych) => (
                  <option key={psych?._id} value={psych?._id}>
                    {psych.name}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminChat;